import React from "react";
import {
  useDispatch,
  useSelector
} from "react-redux";
import { useTranslation } from "react-i18next";
// Core & Lab
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
// Actions
import { hideTimerWarning } from "./redux/reducer";
// Types
import { AppState } from "../../reducers";

const FlightTimerWarning = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const show_timer_warning = useSelector((state: AppState) => state.flight.show_timer_warning);
  const onClose = () => {
    dispatch(hideTimerWarning());
  };
  return (
    <Dialog open={ show_timer_warning } onClose={ onClose }>
      <DialogTitle>
        <Typography style={{color: '#319FE3'}}>
          { t('flight-timer-warning-title') }
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          { t('flight-timer-warning') }
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant={ 'outlined' } onClick={ onClose } style={{borderColor: '#319FE3', color: '#319FE3'}}>{ t('flight-timer-understood') }</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlightTimerWarning;